// userSnapshot.js
import { md5 } from 'js-md5';

const Default_SDK_CONFIG = {
  apikey: 'remarking',
  apiSecret: 'f0a6a55d6f870fd993435a87f80f31b0',
  secretKey: 'remarking',
  apiUrl: 'https://e.adsale.com.hk/RemarketingSDK/api/UserBehaviorSDK/',
  projectCode: 'CPS22DB',
  showId: '9991',
  pageID: '450',           // From genuishelper
  firstVisitDelay: 2500,
  debug: true,             
  hitType: 'popup',
  PlatForm: 'web',
  langId : '936',                 
  cookieGuid : '',
  regSource : '',
  urlName : window.location.pathname
};


export function createUserSnapshot({
  ...overrides
} = {}) {

  const SDK_CONFIG = { ...Default_SDK_CONFIG, ...overrides };

  const timestamp = Date.now();
  const nonce = Math.floor(Math.random() * 90000) + 10000;
  const signature = md5(
    `${SDK_CONFIG.apikey}#${SDK_CONFIG.apiSecret}#${timestamp}#${nonce}`
  );

  const instance = new UserSnapshotSDK({
    secretKey: SDK_CONFIG.secretKey,
    apiUrl: SDK_CONFIG.apiUrl,
    projectCode: SDK_CONFIG.projectCode,
    showId: SDK_CONFIG.showId,
    LangId: SDK_CONFIG.langId,              
    cookieGuid:  SDK_CONFIG.cookieGuid,
    PageId: SDK_CONFIG.pageID,
    UrlName: SDK_CONFIG.urlName,
    RegSource:  SDK_CONFIG.regSource,
    apikey: SDK_CONFIG.apikey,
    signature,
    timestamp,
    nonce,
    firstVisitDelay: SDK_CONFIG.firstVisitDelay,
    debug: SDK_CONFIG.debug,
    hitType: SDK_CONFIG.hitType,
    PlatForm: SDK_CONFIG.PlatForm,
  });

  return instance;
}